import { render } from "./RadioGroupItems.vue?vue&type=template&id=365c5854&scoped=true"
import script from "./RadioGroupItems.vue?vue&type=script&lang=js"
export * from "./RadioGroupItems.vue?vue&type=script&lang=js"

import "./RadioGroupItems.vue?vue&type=style&index=0&id=365c5854&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365c5854"]])

export default __exports__